import { MutationTree } from 'vuex'

import { MapData, Mutations, PostcodeData, PostcodeState } from './types'

const mutations: MutationTree<PostcodeState> = {
  [Mutations.SET_MAP_DATA](state, value: MapData) {
    state.mapData = value
    sessionStorage.setItem('mapData', JSON.stringify(value))
  },

  [Mutations.SET_POSTCODE](state, postcode: string) {
    state.mapData = {
      ...state.mapData,
      postcode,
    }
  },

  [Mutations.SET_POSTCODES_DATA](state, postcodeData: PostcodeData) {
    state.postcodes = {
      ...state.postcodes,
      [postcodeData.postcode]: postcodeData,
    }
  },
}

export default mutations
